import OurBrands from './OurBrands'
export default OurBrands
